var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9738 15.4306C31.9738 12.9254 34.0201 10.8922 36.5415 10.8922V9.07682C36.5415 1.81536 34.7144 0 27.4061 0H9.13538C1.82708 0 0 1.81536 0 9.07682V9.9845C2.52136 9.9845 4.56769 12.0177 4.56769 14.5229C4.56769 17.0281 2.52136 19.0613 0 19.0613V19.969C0 27.2304 1.82708 29.0458 9.13538 29.0458H27.4061C34.7144 29.0458 36.5415 27.2304 36.5415 19.969C34.0201 19.969 31.9738 17.9358 31.9738 15.4306Z",
    fill: "#1C5158"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_1908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2119 20.6128H23.8995C24.1574 20.6128 24.3682 20.402 24.3682 20.1443V14.1709H19.2119V20.6128Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1807 20.1443C12.1807 20.402 12.3916 20.6128 12.6494 20.6128H17.337V14.1709H12.1807V20.1443Z",
    fill: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8371 9.83759H20.3633C21.602 9.61368 22.7311 9.05922 23.2679 8.31779C23.685 7.7419 23.7316 7.0825 23.3995 6.46078C23.0657 5.83639 22.4283 5.53785 21.6488 5.64193C20.4999 5.79527 19.0407 6.84735 18.2745 8.21306C17.5082 6.84735 16.049 5.79527 14.9001 5.64193C14.1215 5.53795 13.4833 5.8365 13.1496 6.46078C12.8174 7.0825 12.8642 7.74201 13.2812 8.31789C13.8178 9.05932 14.9467 9.61368 16.1855 9.83759H11.7119C11.4541 9.83759 11.2432 10.0484 11.2432 10.3061V12.6486C11.2432 12.9062 11.4541 13.1171 11.7119 13.1171H17.337V9.83759H19.212V13.1171H24.8371C25.0949 13.1171 25.3059 12.9062 25.3059 12.6486V10.3061C25.3059 10.0484 25.0949 9.83759 24.8371 9.83759ZM14.0406 7.76857C13.8337 7.48298 13.8133 7.20757 13.9766 6.90228C14.0585 6.74894 14.2098 6.5578 14.593 6.5578C14.649 6.5578 14.7097 6.56187 14.776 6.57075C15.7373 6.69904 17.0816 7.75764 17.6227 9.00321C16.2142 9.06168 14.5913 8.52927 14.0406 7.76867V7.76857ZM18.9264 9.00311C19.4675 7.75754 20.8117 6.69904 21.773 6.57065C22.2932 6.50147 22.4786 6.72666 22.5724 6.90217C22.7357 7.20746 22.7153 7.48287 22.5084 7.76835C21.9577 8.52916 20.3358 9.06189 18.9264 9.003V9.00311Z",
    fill: "#F4F5F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_1908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0627,
    height: 14.9914,
    fill: "white",
    transform: "translate(11.2432 5.62158)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.db3e3e11b91760f289a6454549219f9f.svg";
export { ForwardRef as ReactComponent };